import * as yup from 'yup';
import { adminStore } from '../../../../stores';
import { useFormik } from 'formik';
import { encodeQueryData, refreshQuery } from '../../../../utils/utils';
import { AdminController } from '../../../../controllers';
import constant from '../../../../utils/constant';
import { MimaToastUtil } from '../../../../components';

export const useAdminUpdateOrdersLogic = ({ closeModal }) => {
	const data = adminStore.selectedOrder;
	const businessId = adminStore.businessId;

	const getValidDate = value => {
		if (!value) return null;
		if (value instanceof Date && !Number.isNaN(value.getTime())) return value;
		const parsed = new Date(value);
		return Number.isNaN(parsed.getTime()) ? null : parsed;
	};

	const initialValues = {
		id: data?._id || '',
		trackingStatus: data?.trackingStatus ? data?.trackingStatus : '',
		trackingNumber: data?.trackingNumber ? data?.trackingNumber : '',
		shippingVendor: data?.shippingVendor ? data?.shippingVendor : '',
		shippingTrackingUrl: data?.shippingTrackingUrl
			? data?.shippingTrackingUrl
			: '',
		expectedDeliveryDate: getValidDate(data?.expectedDeliveryDate),
	};

	const validationSchema = () =>
		yup.object({
			trackingStatus: yup.string().required('Please select status'),
			// trackingNumber: string().when("trackingStatus", {
			//   is: "SHIPPED",
			//   then: yup.string().required("Please Enter Tracking Number"),
			//   otherwise: string().optional(),
			// }),
			// shippingVendor: string().when("trackingStatus", {
			//   is: "SHIPPED",
			//   then: yup.string().required("Please Enter Shipping Vendors Name"),
			//   otherwise: string().optional(),
			// }),
			// shippingTrackingUrl: string().when("trackingStatus", {
			//   is: "SHIPPED",
			//   then: yup
			//     .string()
			//     .required("Please Enter Shipping Tracking web Link or Url"),
			//   otherwise: string().optional(),
			// }),
			// expectedDeliveryDate: string().when("trackingStatus", {
			//   is: "SHIPPED",
			//   then: yup.string().required("Please Enter Shipping Delivery date"),
			//   otherwise: string().optional(),
			// }),
		});

	const onSubmit = async values => {
		const expectedDeliveryDate = values?.expectedDeliveryDate
			? new Date(values.expectedDeliveryDate).toISOString()
			: '';

		const query = {
			...(values?.trackingNumber && { trackingNumber: values?.trackingNumber }),
			...(values?.shippingVendor && { shippingVendor: values?.shippingVendor }),
			...(values?.shippingTrackingUrl && {
				shippingTrackingUrl: values?.shippingTrackingUrl,
			}),
			...(expectedDeliveryDate && {
				expectedDeliveryDate,
			}),
		};

		let encodeQuery;

		if (values.trackingStatus === 'SHIPPED') {
			encodeQuery = encodeQueryData({
				...query,
			});
		} else {
			encodeQuery = '';
		}

		const payload = {
			trackingStatus: values.trackingStatus,
			id: values.id,
		};
		const { status, errorMessage } = await AdminController.updateOrderStatus(
			payload,
			encodeQuery
		);

		if (status === constant.Success) {
			refreshQuery({ queryKey: [businessId, constant.apiQueryKey.getOrders] });
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}

		return MimaToastUtil.error({
			message: errorMessage,
		});
	};
	const formik = useFormik({
		initialValues,
		validationSchema,
		onSubmit,
	});

	const status = [
		{
			key: 'DELIVERED',
			value: 'DELIVERED',
		},
		{
			key: 'PROCESSING',
			value: 'PROCCESSING',
		},
		{
			key: 'REFUNDED',
			value: 'REFUNDED',
		},
		{
			key: 'SHIPPED',
			value: 'SHIPPED',
		},
		{
			key: 'VOID',
			value: 'VOID',
		},
	];

	return { formik, status };
};

export default useAdminUpdateOrdersLogic;
